import dummyFunction from '@/lib/utils/dummyFunction';
import { createContext } from 'react';

const TreeWrapperScrollContext = createContext<() => void>(dummyFunction);

export default TreeWrapperScrollContext;
